export type StoreConfig = {
  keyPath: string;
  autoIncrement?: boolean;
};

export type DBSchemaDefinition = {
  name: string;
  version: number;
  stores: Record<string, StoreConfig>;
};

export const dbSchema: DBSchemaDefinition = {
  name: "IM-db",
  version: 1,
  stores: {
    ProductsFromCustomer: {
      keyPath: "id",
      autoIncrement: true,
    }, 
  },
};
 